import { notification } from 'antd'
import { NotificationPlacement } from 'antd/es/notification/interface'

notification.config({
  placement: 'top',
  top: 'calc(env(safe-area-inset-top, 0px) + 24px)' as unknown as number,
  duration: 3,
})

const appNotification = {
  success: (message: string, title?: string, placement?: NotificationPlacement) => {
    notification.success({
      message: title ?? 'Success',
      description: message,
      placement: placement ?? 'top',
    })
  },
  info: (message: string, title?: string, placement?: NotificationPlacement) => {
    notification.info({
      message: title ?? 'Information',
      description: message,
      placement: placement ?? 'top',
    })
  },
  warning: (message: string, title?: string, placement?: NotificationPlacement) => {
    notification.warning({
      message: title ?? 'Warning',
      description: message,
      placement: placement ?? 'top',
    })
  },
  error: (message: string, title?: string, placement?: NotificationPlacement) => {
    notification.error({
      message: title ?? 'Error',
      description: message,
      placement: placement ?? 'top',
    })
  },
}

export default appNotification
